<template>
  <v-card v-if="$can('sensitive-data')">
    <v-card-title>
      <span class="text-h5">
        {{ $t('ITEM.ADD') }} {{ $t('DEVICES.ITEM') }}
      </span>

      <v-spacer />

      <v-btn icon @click="cancel">
        <v-icon>mdi-close</v-icon>
      </v-btn>
    </v-card-title>

    <v-card-text>
      <div class="d-flex justify-space-between">
        <p class="text-body-1">
          <span class="text--secondary">
            {{ $t('DEVICES.DATE_OF_REGISTRATION') }}:
          </span>
          <span class="text--primary">
            {{ device.from | dateFormat }}
          </span>
        </p>
      </div>

      <v-form ref="form" v-model="valid" lazy-validation>
        <device-form
          v-model="device"
          :type="$options.type"
          :errors="errors.getAll()"
          @update-prop="clearErrorByName($event)"
        />
      </v-form>
      <confirm-dialog ref="confirm" />
    </v-card-text>

    <v-card-actions>
      <v-btn outlined depressed color="grey" @click="cancel">
        {{ $t('BUTTON.CANCEL') }}
      </v-btn>

      <v-spacer />

      <v-btn depressed color="primary" :disabled="!valid" @click="create">
        {{ $t('BUTTON.CREATE') }}
      </v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
import { mapActions } from 'vuex';
import errors from '@/modules/_global/mixins/errors';
import { onceRequest } from '@/modules/_global/utils/common';
import { dateFormat, dateFormatBackend } from '@/modules/_global/filters';
import { WarehouseDevicesService } from '@/services/warehouse-devices.service';
import DeviceForm, {
  WAREHOUSE
} from '@/modules/devices/components/forms/DeviceForm.vue';
import checkDeviceCode from '@/modules/devices/mixins/checkDeviceCode';
import ConfirmDialog from '@/modules/_global/_components/ConfirmDialog';

export default {
  name: 'CreateDevice',

  type: WAREHOUSE,

  filters: {
    dateFormat
  },

  components: {
    ConfirmDialog,
    DeviceForm
  },

  mixins: [errors, checkDeviceCode],

  data() {
    return {
      valid: true,
      device: {
        from: dateFormatBackend(new Date()),
        available_for_market: true
      }
    };
  },

  methods: {
    ...mapActions('snackbar', ['setSnack']),

    cancel() {
      this.$emit('cancel');
    },

    create: onceRequest(function create() {
      if (!this.$refs.form.validate()) {
        return;
      }

      return this.checkWarhouseDeviceCode()
        .then(confirm => {
          return !confirm || this.showConfirm();
        })
        .then(confirm => {
          if (confirm) {
            return this.createDevice();
          }
        });
    }),

    createDevice() {
      return WarehouseDevicesService.create(this.device)
        .then(({ data }) => {
          this.setSnack({
            status: 'success',
            text: this.$t('MESSAGE.SUCCESS')
          });

          this.$emit('created', data.data);
        })
        .catch(this.handleErrors);
    }
  }
};
</script>
